import AddToWishlistModal from './add-to-wishlist-modal'

export default AddToWishlistModal;